// Matches goserver's 50 MB request limit, so an oversized file is refused here with a clear message.
export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024;

// Returns the message to show for a file the server would refuse, or '' when the file can be sent.
// A missing MIME type is allowed through: some browsers leave it empty for formats like .mkv, and goserver checks
// the file itself anyway.
export const trial_video_file_error = (file) => {
  if (!file) {
    return 'Choose a video file';
  }
  if (file.size === 0) {
    return 'The file is empty';
  }
  if (file.size > MAX_UPLOAD_BYTES) {
    return 'The file is larger than 50 MB';
  }
  if (file.type && !file.type.startsWith('video/')) {
    return 'The file is not a video';
  }
  return '';
};
